<app-admin-appbar></app-admin-appbar>
<br />

<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
  <div class="d-flex flex-wrap gap-2">
    <div class="d-flex flex-column">
      <label class="form-label small text-muted mb-1" for="admin_manager_filter_status">
        Status
      </label>
      <kendo-dropdownlist
        id="admin_manager_filter_status"
        [defaultItem]="{ text: 'All', value: null }"
        textField="text"
        valueField="value"
        [data]="statusOptions"
        [style]="{ width: '200px' }"
        (valueChange)="statusChange($event)"
      ></kendo-dropdownlist>
    </div>
    <div class="d-flex flex-column">
      <label class="form-label small text-muted mb-1" for="admin_manager_filter_default_state">
        Default State
      </label>
      <kendo-dropdownlist
        id="admin_manager_filter_default_state"
        [defaultItem]="{ text: 'All', value: null }"
        textField="text"
        valueField="value"
        [data]="defaultStateOptions"
        [style]="{ width: '200px' }"
        (valueChange)="defaultStateChange($event)"
      ></kendo-dropdownlist>
    </div>
  </div>
  <button
    kendoButton
    class="align-self-end"
    (click)="addDetection(bodyElement)"
    [svgIcon]="plusIcon"
    themeColor="primary"
  >
    Add Detection
  </button>
</div>

<app-datatable
  [data-href]="datatableUrl"
  [columns]="datatableColumns"
  [useOData]="true"
  [initialFilters]="initialFilters"
  [clickableRows]="true"
  (rowClick)="editDetection($event)"
></app-datatable>
